window.addEventListener('load', function () {
    const tableFilters = document.querySelectorAll('.table-filter-container');
    const filterPickers = this.document.querySelectorAll('.filter-picker');
    const chartFilters = this.document.querySelectorAll('.chart-filter-container');
    const sortFilters = this.document.querySelectorAll('.sort-filter');
    const columnFilters = document.querySelectorAll('.table-column-filter-container');

    document.addEventListener('click', function (event) {
        event.stopPropagation();

        if (!event.target.classList.contains('table-filter-label') &&
            !event.target.classList.contains('table-filter') &&
            !event.target.parentNode.classList.contains('table-filter-label') &&
            event.target.type !== 'checkbox' &&
            !event.target.parentNode.classList.contains('filter-picker') &&
            !event.target.parentNode.parentNode.classList.contains('filter-picker') &&
            !event.target.parentNode.classList.contains('sort-filter') &&
            !event.target.parentNode.parentNode.classList.contains('sort-filter')) {
            hideOpenedFilters();
            hideOpenedFilterPickers();
            hideOpenedSortFilters();
            hideOpenedColumnFilters();
        }
    });

    for (let i = 0, len = sortFilters.length; i < len; i++) {
        let sortFilterLabel = sortFilters[i].querySelector('.table-filter-label');
        let sortFilterList = sortFilters[i].querySelector('.table-filters');
        let sortFilterLabelText = sortFilterLabel.querySelector('.label-text');
        let sortFilterCells = sortFilterList.querySelectorAll('.table-filter');

        sortFilterLabel.addEventListener('click', function () {
            toggleTableFiltersOpenClass(sortFilters[i], sortFilterList);
        });

        for (let j = 0, leng = sortFilterCells.length; j < leng; j++) {
            sortFilterCells[j].addEventListener('click', function () {
                sortFilterLabelText.textContent = this.textContent;
                let previousSelected = sortFilters[i].querySelector('.table-filter.selected');
                if (previousSelected) {
                    previousSelected.classList.remove('selected');
                }
                this.classList.add('selected');
                toggleTableFiltersOpenClass(sortFilters[i], sortFilterList);
            });
        }
    }

    for (let i = 0, len = columnFilters.length; i < len; i++) {
        let columnFilterLabel = columnFilters[i].querySelector('.table-filter-label');
        let columnFilterList = columnFilters[i].querySelector('.table-filters');
        let columnFilterCells = columnFilterList.querySelectorAll('.table-filter');
        let columnFilterTable = columnFilters[i].parentNode.nextElementSibling;

        columnFilterLabel.addEventListener('click', function () {
            toggleTableFiltersOpenClass(columnFilters[i], columnFilterList);
        });

        for (let j = 0, leng = columnFilterCells.length; j < leng; j++) {
            columnFilterCells[j].addEventListener('click', function (event) {
                if (event.target.tagName !== 'INPUT') {
                    let checkbox = this.querySelector('input');

                    if (checkbox.checked) {
                        checkbox.checked = false;
                    } else {
                        checkbox.checked = true;
                    }
                }
                filterTableColumns(this, columnFilterTable);
            });
        }
    }

    for (let i = 0, len = filterPickers.length; i < len; i++) {
        let filterPickerLabel = filterPickers[i].querySelector('.table-filter-label');
        let filterPickerLabelText = filterPickerLabel.querySelector('.label-text');
        let filterPickerList = filterPickers[i].querySelector('.table-filters');
        let filterPickerCells = filterPickerList.querySelectorAll('.table-filter');
        let filterContainers = filterPickers[i].parentNode.parentNode.querySelectorAll('.table-filter-container.filter-pick');
        let filterPickerTable = filterPickers[i].parentNode.parentNode.nextElementSibling;

        filterPickerLabel.addEventListener('click', function () {
            toggleTableFiltersOpenClass(filterPickers[i], filterPickerList);
        });

        for (let j = 0, leng = filterPickerCells.length; j < leng; j++) {
            filterPickerCells[j].addEventListener('click', function () {
                filterPickerLabelText.textContent = this.textContent;
                let previousSelected = filterPickers[i].querySelector('.table-filter.selected');
                if (previousSelected) {
                    previousSelected.classList.remove('selected');
                }
                this.classList.add('selected');
                toggleTableFiltersOpenClass(filterPickers[i], filterPickerList);
                showPickedFilter(this, filterContainers);
                showAllTable(filterPickerTable);
            });
        }
    }

    for (let i = 0, len = tableFilters.length; i < len; i++) {
        let filterLabel = tableFilters[i].querySelector('.table-filter-label');
        let defaultLabelText = filterLabel.querySelector('.label-text-default');
        let selectedLabelText = filterLabel.querySelector('.label-text-selected');
        let searchField = filterLabel.querySelector('input');
        let table = tableFilters[i].parentNode.nextElementSibling;
        let filterList = tableFilters[i].querySelector('.table-filters');
        let tableFilterList = '';
        let noFilterFoundText = filterList.querySelector('.no-filter-found');
        let checkboxFilter = false;
        let kanditateFilter = false;
        let otherFilter = false;
        let filterCells = '';

        if (filterList.classList.contains('kandidate-filters')) {
            kanditateFilter = true;
        }

        if (filterList.classList.contains('party-filters') || filterList.classList.contains('other-filters')) {
            otherFilter = true;
        }

        filterLabel.addEventListener('click', function (event) {
            event.stopPropagation();

            let eventTarget = event.target;

            tableFilterList = filterList.querySelectorAll('.table-filter input');

            if (tableFilterList.length) {
                checkboxFilter = true;
                setCheckBoxEvent(tableFilterList, table, filterLabel);
            } else {
                tableFilterList = filterList.querySelectorAll('.table-filter');
                filterCells = table.querySelectorAll('.' + filterList.dataset.info);
                let resetFilter = filterLabel.querySelector('.reset-filter');

                if (resetFilter) {
                    resetFilter.addEventListener('click', function () {
                        let previousSelected = tableFilters[i].querySelector('.table-filter.selected');
                        if (previousSelected) {
                            previousSelected.classList.remove('selected');
                        }
                        defaultLabelText.classList.remove('hidden');
                        selectedLabelText.classList.add('hidden');
                        selectedLabelText.querySelector('.selected-text').textContent = '';
                        resetFilter.classList.add('hidden');

                        emptySearchField(tableFilters[i]);

                        if (otherFilter) {
                            showAllKandidates(tableFilters[i]);
                            filterTable('', filterCells);
                        }

                        if (kanditateFilter) {
                            enableOtherFilters(tableFilters[i], filterCells, table);
                            let otherSelectedFilterText = this.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('.label-text-selected:not(.hidden)');

                            if (otherSelectedFilterText) {
                                let otherSelectedFilters = otherSelectedFilterText.parentNode.parentNode.parentNode.querySelectorAll('.table-filter');
                                let selectedText = otherSelectedFilterText.querySelector('.selected-text').textContent;
                                let otherSelectedFilter;

                                for (let i = 0, len = otherSelectedFilters.length; i < len; i++) {
                                    if (otherSelectedFilters[i].textContent === selectedText) {
                                        otherSelectedFilter = otherSelectedFilters[i];
                                        break;
                                    }
                                }

                                filterKandidateFilter(otherSelectedFilter, table);
                            }
                        }
                    });
                }

                for (let j = 0, len = tableFilterList.length; j < len; j++) {
                    tableFilterList[j].addEventListener('click', function () {
                        let previousSelected = tableFilters[i].querySelector('.table-filter.selected');
                        if (previousSelected) {
                            previousSelected.classList.remove('selected');
                        }
                        this.classList.add('selected');
                        defaultLabelText.classList.add('hidden');
                        selectedLabelText.querySelector('.selected-text').textContent = this.textContent;
                        selectedLabelText.classList.remove('hidden');
                        filterList.classList.remove('table-filters-open');
                        filterLabel.classList.remove('table-filters-open');
                        resetFilter.classList.remove('hidden');

                        searchFilter(searchField, tableFilterList, filterList, noFilterFoundText, checkboxFilter);

                        if (kanditateFilter) {
                            disableOtherFilters(this);
                        }

                        filterTable(this.textContent, filterCells);

                        if (otherFilter) {
                            filterKandidateFilter(this, table);
                        }
                    });
                }
            }

            if (eventTarget.tagName !== 'INPUT' &&
                !eventTarget.classList.contains('reset-filter') &&
                eventTarget.id !== 'Vereinigungsmenge_3' &&
                !(eventTarget.tagName === 'svg' && eventTarget.querySelector('#Vereinigungsmenge_3'))) {
                toggleTableFiltersOpenClass(this, filterList);
                searchField.focus();
            }
        });

        searchField.addEventListener('keyup', function () {
            searchFilter(this, tableFilterList, filterList, noFilterFoundText, checkboxFilter);
        });
    }

    for (let i = 0, len = chartFilters.length; i < len; i++) {
        let chartFilter = chartFilters[i];

        let filterLabel = chartFilters[i].querySelector('.table-filter-label');
        let defaultLabelText = filterLabel.querySelector('.label-text-default');
        let selectedLabelText = filterLabel.querySelector('.label-text-selected');
        let searchField = filterLabel.querySelector('input');
        let filterList = chartFilters[i].querySelector('.table-filters');
        let tableFilterList = '';
        let noFilterFoundText = filterList.querySelector('.no-filter-found');

        filterLabel.addEventListener('click', function (event) {
            event.stopPropagation();

            let eventTarget = event.target;

            tableFilterList = filterList.querySelectorAll('.table-filter');

            let resetFilter = filterLabel.querySelector('.reset-filter');

            if (resetFilter) {
                const resetFilterHandler = function () {
                    defaultLabelText.classList.remove('hidden');
                    selectedLabelText.classList.add('hidden');
                    let previousSelected = chartFilters[i].querySelector('.table-filter.selected');
                    if (previousSelected) {
                        previousSelected.classList.remove('selected');
                    }
                    selectedLabelText.querySelector('.selected-text').textContent = '';
                    resetFilter.classList.add('hidden');
                    searchField.dispatchEvent(new KeyboardEvent('keyup', {'key': '13'}));
                }

                document.addEventListener('reset-chart-filter', function (e) {
                    if (!e.detail) return ;

                    if (e.detail.chartId === chartFilter.id) {
                        resetFilterHandler();
                    }
                });

                resetFilter.addEventListener('click', resetFilterHandler);
            }

            for (let j = 0, len = tableFilterList.length; j < len; j++) {
                tableFilterList[j].addEventListener('click', function () {
                    defaultLabelText.classList.add('hidden');
                    selectedLabelText.querySelector('.selected-text').textContent = this.textContent;
                    selectedLabelText.classList.remove('hidden');
                    filterList.classList.remove('table-filters-open');
                    filterLabel.classList.remove('table-filters-open');
                    resetFilter.classList.remove('hidden');
                    let previousSelected = chartFilters[i].querySelector('.table-filter.selected');
                    if (previousSelected) {
                        previousSelected.classList.remove('selected');
                    }
                    this.classList.add('selected');
                    searchFilter(searchField, tableFilterList, filterList, noFilterFoundText, false);
                });
            }

            if (eventTarget.tagName !== 'INPUT' &&
                !eventTarget.classList.contains('reset-filter') &&
                eventTarget.id !== 'Vereinigungsmenge_3' &&
                !(eventTarget.tagName === 'svg' && eventTarget.querySelector('#Vereinigungsmenge_3'))) {
                toggleTableFiltersOpenClass(this, filterList);
                searchField.focus();
            }
        });

        searchField.addEventListener('keyup', function () {
            searchFilter(this, tableFilterList, filterList, noFilterFoundText, false);
        });
    }

    function searchFilter(searchField, tableFilterList, filterList, noFilterFoundText, checkboxFilter) {
        for (let j = 0, leng = tableFilterList.length; j < leng; j++) {
            let filterContent = tableFilterList[j].textContent;
            let filterChangeClass = tableFilterList[j];

            if (checkboxFilter) {
                filterContent = tableFilterList[j].value;
                filterChangeClass = tableFilterList[j].parentNode;
            }

            const haystack = filterContent
                .toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            const needle = searchField
                .value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

            if (haystack
                .search(needle) !== -1) {
                filterChangeClass.classList.remove('hidden');
                noFilterFoundText.classList.add('hidden');
            } else {
                filterChangeClass.classList.add('hidden');
            }
        }

        if (filterList.querySelectorAll('.table-filter.hidden').length === tableFilterList.length) {
            noFilterFoundText.classList.remove('hidden');
        }
    }

    function setCheckBoxEvent(checkBoxList, table, filterLabel) {
        let filterCells = table.querySelectorAll('.filter-cell');
        let filterNumber = filterLabel.querySelector('.table-filter-number');
        let checkedFilterNumber = 0;

        if (filterNumber) {
            checkedFilterNumber = parseInt(filterNumber.textContent);
        }

        for (let i = 0, len = checkBoxList.length; i < len; i++) {
            checkBoxList[i].addEventListener('change', function (event) {
                if (!this.parentNode.parentNode.parentNode.parentNode.classList.contains('custom-legend')) {
                    if (this.value === 'all') {
                        setAllCheckboxes(checkBoxList, this.checked);
                    } else {
                        checkAllCheckboxes(checkBoxList, this.checked);
                    }
                }

                for (let j = 0, leng = filterCells.length; j < leng; j++) {
                    if (filterCells[j].textContent === this.value) {
                        switch (event.target.checked) {
                            case true:
                                filterCells[j].parentNode.classList.remove('hidden');
                                checkedFilterNumber += 1;
                                break;
                            case false:
                                filterCells[j].parentNode.classList.add('hidden');
                                checkedFilterNumber -= 1;
                                break;
                        }
                    }
                }

                if (filterNumber) {
                    filterNumber.textContent = checkedFilterNumber.toString();
                }
            });
        }
    }

    function filterTable(selectedFilter, filterCells) {
        for (let i = 0, len = filterCells.length; i < len; i++) {
            if (filterCells[i].textContent === selectedFilter || selectedFilter === '') {
                filterCells[i].parentNode.classList.remove('hidden');
            } else {
                filterCells[i].parentNode.classList.add('hidden');
            }
        }
    }

    function hideOpenedFilters() {
        let openedElements = document.querySelectorAll('.table-filter-label.table-filters-open');

        for (let i = 0, len = openedElements.length; i < len; i++) {
            openedElements[i].click();
        }
    }

    function hideOpenedFilterPickers() {
        let openedFilterPickers = document.querySelectorAll('.filter-picker.table-filters-open');

        for (let i = 0, len = openedFilterPickers.length; i < len; i++) {
            openedFilterPickers[i].classList.remove('table-filters-open');
            openedFilterPickers[i].querySelector('.table-filters').classList.remove('table-filters-open');
        }
    }

    function hideOpenedSortFilters() {
        let openedFilterPickers = document.querySelectorAll('.sort-filter.table-filters-open');

        for (let i = 0, len = openedFilterPickers.length; i < len; i++) {
            openedFilterPickers[i].classList.remove('table-filters-open');
            openedFilterPickers[i].querySelector('.table-filters').classList.remove('table-filters-open');
        }
    }

    function disableOtherFilters(kandidateFilter) {
        let otherFilters = kandidateFilter.parentNode.parentNode.parentNode.querySelectorAll('.table-filter-container:not(:first-of-type)');

        for (let i = 0, len = otherFilters.length; i < len; i++) {
            otherFilters[i].classList.add('disable-filter');
        }

        let filterPicker = kandidateFilter.parentNode.parentNode.parentNode.querySelector('.filter-picker-container');

        if (filterPicker) {
            filterPicker.classList.add('disable-filter');
        }
    }

    function enableOtherFilters(kandidateFilter, filterCells, table) {
        let otherFilters = kandidateFilter.parentNode.parentNode.parentNode.querySelectorAll('.table-filter-container:not(:first-of-type)');
        let selectedFilter = '';

        for (let i = 0, len = otherFilters.length; i < len; i++) {
            let selectedLabelText = otherFilters[i].querySelector('.label-text-selected .selected-text').textContent;

            if (selectedLabelText !== '') {
                selectedFilter = selectedLabelText;
                let tableFilters = otherFilters[i].querySelector('.table-filters');
                filterCells = table.querySelectorAll('.' + tableFilters.dataset.info)
            }

            otherFilters[i].classList.remove('disable-filter');
        }

        let filterPicker = kandidateFilter.parentNode.parentNode.parentNode.querySelector('.filter-picker-container');

        if (filterPicker) {
            filterPicker.classList.remove('disable-filter');
        }

        filterTable(selectedFilter, filterCells);
    }

    function filterKandidateFilter(filter, table) {
        let kandidateFilterList = filter.parentNode.parentNode.parentNode.querySelectorAll('.table-filters.kandidate-filters .table-filter');
        let selectedRowsKandidates = table.querySelectorAll('tr:not(.hidden) .filter-cell-kandidate');

        for (let i = 0, len = kandidateFilterList.length; i < len; i++) {
            for (let j = 0, leng = selectedRowsKandidates.length; j < leng; j++) {
                if (kandidateFilterList[i].textContent === selectedRowsKandidates[j].textContent) {
                    kandidateFilterList[i].classList.remove('hidden');
                    break;
                } else {
                    kandidateFilterList[i].classList.add('hidden');
                }
            }
        }
    }

    function showAllKandidates(filter) {
        let kandidateFilterList = filter.parentNode.parentNode.parentNode.querySelectorAll('.table-filters.kandidate-filters .table-filter');

        for (let i = 0, len = kandidateFilterList.length; i < len; i++) {
            kandidateFilterList[i].classList.remove('hidden');
        }
    }

    function toggleTableFiltersOpenClass(element, filterList) {
        if (element.classList.contains('table-filters-open')) {
            element.classList.remove('table-filters-open');
            filterList.classList.remove('table-filters-open');
        } else {
            hideOpenedFilters();
            hideOpenedFilterPickers();
            hideOpenedSortFilters();
            hideOpenedColumnFilters();

            if (element.querySelector('.filter-search-field')) {
                emptySearchField(element);
            }

            element.classList.add('table-filters-open');
            filterList.classList.add('table-filters-open');
        }
    }

    function showPickedFilter(selected, filterContainers) {
        for (let i = 0, len = filterContainers.length; i < len; i++) {
            if (selected.dataset.filter === filterContainers[i].dataset.filter) {
                filterContainers[i].classList.remove('hidden');
                let previousSelected = filterContainers[i].querySelector('.table-filter.selected');
                if (previousSelected) {
                    previousSelected.classList.remove('selected');
                }
            } else {
                filterContainers[i].classList.add('hidden');
                filterContainers[i].querySelector('.table-filter-label .label-text-default').classList.remove('hidden');
                filterContainers[i].querySelector('.table-filter-label .label-text-selected').classList.add('hidden');
                filterContainers[i].querySelector('.table-filter-label .label-text-selected .selected-text').textContent = '';
            }
        }
    }

    function showAllTable(table) {
        let hiddenRows = table.querySelectorAll('tr.hidden');

        for (let i = 0, len = hiddenRows.length; i < len; i++) {
            hiddenRows[i].classList.remove('hidden');
        }
    }

    function emptySearchField(filterContainer) {
        let searchField = filterContainer.querySelector('input');
        if (searchField.value !== '') {
            searchField.value = '';
            searchField.dispatchEvent(new KeyboardEvent('keyup', {'key': '13'}));
        }
    }

    function setAllCheckboxes(checkBoxList, allChecked) {
        if (allChecked) {
            for (let i = 0, len = checkBoxList.length; i < len; i++) {
                if (!checkBoxList[i].checked) {
                    checkBoxList[i].click();
                }

            }
        } else {
            for (let i = 0, len = checkBoxList.length; i < len; i++) {
                if (checkBoxList[i].checked) {
                    checkBoxList[i].click();
                }
            }
        }
    }

    function checkAllCheckboxes(checkBoxList, checked) {
        if (!checked && checkBoxList[0].checked) {
            checkBoxList[0].checked = false;
        } else {
            var allChecked = true;

            for (let i = 1, len = checkBoxList.length; i < len - 1; i++) {
                if (!checkBoxList[i].checked) {
                    allChecked = false;
                    break;
                }
            }

            if (allChecked) {
                checkBoxList[0].checked = true;
            }
        }
    }

    function filterTableColumns(selected, table) {
        let checkbox = selected.querySelector('input');
        let checked = checkbox.checked;
        let value = checkbox.value;
        let tableTitles = table.querySelectorAll('thead tr th');
        let tableRows = table.querySelectorAll('tbody tr');

        if (checked) {
            tableTitles[value].classList.remove('hidden');

            for (let i = 0, len = tableRows.length; i < len; i++) {
                let tableRowCells = tableRows[i].querySelectorAll('td');
                tableRowCells[value].classList.remove('hidden');
            }
        } else {
            tableTitles[value].classList.add('hidden');

            for (let i = 0, len = tableRows.length; i < len; i++) {
                let tableRowCells = tableRows[i].querySelectorAll('td');
                tableRowCells[value].classList.add('hidden');
            }
        }
    }

    function hideOpenedColumnFilters() {
        let openedColumnFilters = document.querySelectorAll('.table-column-filter-container.table-filters-open');

        for (let i = 0, len = openedColumnFilters.length; i < len; i++) {
            openedColumnFilters[i].classList.remove('table-filters-open');
            openedColumnFilters[i].querySelector('.table-filters').classList.remove('table-filters-open');
        }
    }
});